module.exports = __webpack_public_path__ + "static/media/icon-reserved.319c222a.png";